<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Position" subTitle="Forms" />

    <ListPosition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListPosition from "@/components/Pages/Master/Position/ListPosition.vue";

export default defineComponent({
  name: "ListPositionPage",
  components: {
    PageTitle,
    ListPosition,
  },
});
</script>
